import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingCharacters = function () { return utilBalancing.getBalancing().Characters; };
export var selectBalancingCharacter = memoize(function (id) {
    return selectBalancingCharacters().get(id);
});
export var balancingCharactersMemoizedFunctions = [
    selectBalancingCharacters,
    selectBalancingCharacter,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingCharacters.ts
// module id = 383
// module chunks = 3